import React, { useEffect, useState } from "react";
import { Postrequestcall } from "../../../request/Postrequest";
import { FETCH_CLIENT_TIMESHEETS_V2, FETCH_CLIENTTIMESHEET_HOURS } from "../../../constant/Apipath";
import { useSelector } from "react-redux";
import { Avatar, Box, Card, Grid, IconButton, Modal, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import HelpIcon from "@mui/icons-material/Help";
import moment from "moment";
import Loader from "../../../common/Loader";
import { ClientEnglishFallback } from "../../constant/ClientEnglishFallback";

let CLIENT_COLOR = "#000000";

export default function ClientViewGeneratedTimesheet({ isOpen, onClose, item, setHelpModal }) {
  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  CLIENT_COLOR = selectedClientData?.AccentColor;
  const TOKEN = loginData?.accessToken;
  const USER_ID = loginData?.userInformation?.UserId;

  const { TEXT_DATE, TEXT_ACTIVITIES, TEXT_HOURS, TEXT_JOB, TEXT_FOREMAN, TEXT_SUBMITTED_ON } =
    ClientEnglishFallback?.AddTimesheetModal(multiLanguageData?.AddTimesheetModal || {});

  const [isLoading, setIsLoading] = useState(true);
  const [initialData, setInitialData] = useState([]);
  const [headerData, setHeaderData] = useState([]);

  useEffect(() => {
    if (isOpen === true) {
      getClientIndividualTimesheet();
    }
    return () => {};
  }, [isOpen]);

  // GET TIMESHEET AND JOBS API --->
  const getClientIndividualTimesheet = async () => {
    try {
      const clientTimesheetObject = {
        PageNr: 1,
        FullSearch: "",
        UserId: USER_ID,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SearchList: [{ Id: item?.id }]
      };
      let getClienttimesheet = await Postrequestcall(
        FETCH_CLIENT_TIMESHEETS_V2,
        clientTimesheetObject,
        TOKEN,
        false
      );
      if (getClienttimesheet.status === 200) {
        setHeaderData(getClienttimesheet?.data?.data[0]);
        let getId = getClienttimesheet?.data?.data[0]?.id;
        const timesheetJobObject = {
          PageNr: 1,
          NrOfRecPerPage: 20,
          FullSearch: "",
          UserId: USER_ID,
          IncludeRecordNr: true,
          FetchAllowedRecordsOnly: true,
          SearchList: [
            {
              ClientTimesheetId: getId,
              clientEmployeeId: selectedClientData?.ClientEmployeeId
            }
          ]
        };
        const getResponse = await Postrequestcall(
          FETCH_CLIENTTIMESHEET_HOURS,
          timesheetJobObject,
          TOKEN,
          false
        );
        if (getResponse.status === 200) {
          setInitialData(getResponse?.data?.data);
        }
      }
    } catch (e) {
      console.log("getClientIndividualTimesheet-> Error When Fetching Client Timesheet: ", e);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <Box
        sx={{
          padding: {
            xs: "10px",
            xl: "15px",
            lg: "15px",
            md: "15px",
            sm: "10px"
          },
          maxHeight: "600px",
          overflowY: "scroll"
        }}
        className="client-modal-responsive">
        <Stack sx={{ display: "flex",  justifyContent: "space-between", alignItems: "center" }}  direction={"row"}>
          <IconButton size="small" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Stack>
        {isLoading ? (
          <Loader />
        ) : (
          <>
            <Stack sx={{ marginBottom: "10px",  justifyContent: "space-between", alignItems: "center" }} direction={"row"} >
              <Stack>
                <Typography sx={{ color: "grey" }}>{TEXT_FOREMAN}</Typography>
                <Stack direction={"row"} sx={{ gap: '10px',  alignItems: "center"  }} >
                  <Avatar alt="Remy Sharp" src={initialData[0]?.foremanClientEmployeePicture} />
                  <Typography>{initialData[0]?.foremanClientEmployeeName}</Typography>
                </Stack>
              </Stack>
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  setHelpModal(true);
                }}
                size="small">
                <HelpIcon sx={{ color: "#000000" }} />
              </IconButton>
            </Stack>
            <Grid container sx={{ marginBottom: "10px" }}>
              <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
                <Stack>
                  <Typography sx={{ color: "grey" }}>{TEXT_DATE}</Typography>
                  <Typography>{moment(headerData.date).format("MMMM D, YYYY")}</Typography>
                </Stack>
              </Grid>
              <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
                <Stack>
                  <Typography sx={{ color: "grey" }}>{TEXT_SUBMITTED_ON}</Typography>
                  <Typography>{moment(headerData.dateSubmitted).format("MMMM D, YYYY")}</Typography>
                </Stack>
              </Grid>
            </Grid>
            <Stack sx={{ marginBottom: "10px" }}>
              <Typography sx={{ color: "grey" }}>{TEXT_JOB}</Typography>
              <Typography>
                {`${initialData[0]?.clientJobCode} - ${initialData[0]?.clientJobName}`}
              </Typography>
            </Stack>
            <Typography sx={{ margin: "10px 0px",  fontWeight: "bold" }} >
              {TEXT_ACTIVITIES}
            </Typography>
            {initialData.map((item) => (
              <Card className="pagelist-content" style={{ padding: "15px", marginBottom: "12px" }}>
                <Typography>
                  {" "}
                  {item?.clientJobActivityCode} - {item?.clientJobActivityName}
                </Typography>
                <Stack style={{ marginTop: "10px" }}>
                  <Typography sx={{ color: "grey" }}>{TEXT_HOURS}</Typography>
                  <Typography>{item?.hours}</Typography>
                </Stack>
              </Card>
            ))}
          </>
        )}
      </Box>
    </Modal>
  );
}

